// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dm1U","colBig":"styles_colBig__3s_sA","colSmall":"styles_colSmall__6sfUP","shopifyNameWrapper":"styles_shopifyNameWrapper__ilTGA"};